import { render, staticRenderFns } from "./payPage.vue?vue&type=template&id=71a588e5&scoped=true"
import script from "./payPage.vue?vue&type=script&lang=js"
export * from "./payPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a588e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a588e5')) {
      api.createRecord('71a588e5', component.options)
    } else {
      api.reload('71a588e5', component.options)
    }
    module.hot.accept("./payPage.vue?vue&type=template&id=71a588e5&scoped=true", function () {
      api.rerender('71a588e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/registrationQuery/views/payPage.vue"
export default component.exports